// extracted by mini-css-extract-plugin
module.exports = {"image":"cN","image-placeholder":"cO","imagePlaceholder":"cO"};